import React from "react"
import { Link } from "gatsby"
import { motion, AnimatePresence } from "framer-motion"
import { DialogOverlay, DialogContent } from "@reach/dialog"
import css from "@styled-system/css"

import "@reach/dialog/styles.css"

// import closeCursor from "../../../images/closeCursor.png"

import { Box, Flex } from "components"

const Logo = ({ onClick }) => (
  <Link
    to="/"
    onClick={onClick}
    css={{ "&:focus": { outline: 0 }, "::-moz-focus-inner": { border: 0 } }}
  >
    <svg width={(133 / 46) * 40} height={40} viewBox="0 0 133 46" fill="#fff">
      <path
        d="M57.498 6.93l2.568-1.053V17.49c0 .836.195 1.006.617 1.006a.988.988 0 00.469-.123v1.246c-.555.31-1.133.48-1.726.48-.672 0-1.195-.263-1.53-.697a3.23 3.23 0 01-2.007.697c-2.35 0-3.545-1.649-3.545-4.614 0-2.958 1.203-4.607 3.545-4.607.593 0 1.148.155 1.616.441V6.93h-.008zm0 7.007a1.515 1.515 0 00-1.265-.658c-1 0-1.328.79-1.328 2.214 0 1.433.328 2.222 1.328 2.222.507 0 .968-.232 1.265-.658v-3.12zM66.773 20.1c-2.592 0-3.99-1.533-3.99-4.614 0-3.067 1.398-4.607 3.99-4.607 2.585 0 3.982 1.533 3.982 4.607-.007 3.081-1.397 4.614-3.982 4.614zm-1.42-4.607c0 1.48.42 2.2 1.413 2.2.991 0 1.413-.72 1.413-2.2 0-1.463-.422-2.19-1.413-2.19-.992-.009-1.414.727-1.414 2.19zM76.236 19.884h-1.85l-2.108-8.78h2.233l1.038 4.35 1.445-4.35h1.858l1.437 4.35 1.046-4.35h2.233l-2.1 8.78h-1.859l-1.678-4.282-1.695 4.282zM88.042 19.884h-2.569v-8.278l2.569-1.053v1.053c.71-.371 1.702-.72 2.303-.72 1.976 0 2.577 1.293 2.577 3.074v5.931h-2.577V14.55c0-.89-.374-1.162-.976-1.162-.351 0-.843.202-1.327.504v5.993zM98.793 13.542v1.951c0 1.913-.023 2.44 1.242 2.44.312 0 .734-.132 1.085-.357v1.99c-.64.333-1.35.527-1.952.527-2.608 0-2.943-1.255-2.943-3.957v-2.61h-1.437v-2.438h1.437V9.067l2.56-1.053v3.074h2.327v2.439h-2.319v.015zM106.851 20.1c-2.584 0-3.982-1.533-3.982-4.614 0-3.067 1.398-4.607 3.982-4.607 2.592 0 3.982 1.533 3.982 4.607.008 3.081-1.382 4.614-3.982 4.614zm-1.405-4.607c0 1.48.414 2.2 1.413 2.2.999 0 1.421-.72 1.421-2.2 0-1.463-.422-2.19-1.421-2.19-.999-.009-1.413.727-1.413 2.19zM116.33 19.884h-1.858l-2.1-8.78h2.233l1.038 4.35 1.437-4.35h1.858l1.437 4.35 1.038-4.35h2.241l-2.108 8.78h-1.858l-1.679-4.282-1.679 4.282zM128.128 19.884h-2.569v-8.278l2.569-1.053v1.053c.71-.371 1.71-.72 2.303-.72 1.968 0 2.569 1.293 2.569 3.074v5.931h-2.569V14.55c0-.89-.375-1.162-.976-1.162-.351 0-.843.202-1.327.504v5.993zM56.38 36.57c-2.474 0-4.044-1.55-4.044-4.608 0-3.252 1.804-4.614 3.959-4.614 2.46 0 3.435 1.672 2.99 3.53H57.03c.172-.62-.047-1.115-.734-1.115-.882 0-1.39.62-1.39 2.261 0 1.456.492 2.153 1.726 2.153 1.085 0 1.772-.31 2.772-.883v2.439c-.758.348-1.601.836-3.022.836zM68.913 27.348v6.604c0 .836.195 1.007.624 1.007a.925.925 0 00.461-.132v1.247c-.554.31-1.124.48-1.726.48-.663 0-1.194-.264-1.522-.697a3.236 3.236 0 01-2.014.697c-2.343 0-3.538-1.65-3.538-4.607 0-2.966 1.203-4.615 3.538-4.615.843 0 1.569.31 2.147.836l2.03-.82zm-2.57 3.05a1.525 1.525 0 00-1.264-.658c-1 0-1.327.798-1.327 2.222 0 1.425.328 2.215 1.327 2.215.508 0 .976-.24 1.265-.658v-3.12zM72.122 36.345V23.399l2.568-1.053v13.999h-2.568zM85.403 30.003h-1.171c.047.24.062.596.062.767 0 2.13-1.194 3.205-3.474 3.205h-.484c-.375 0-.602.31-.602.62 0 .286.18.565.508.565h.617c2.639 0 3.99.991 3.99 2.834s-1.351 2.826-3.99 2.826c-2.631 0-3.982-.991-3.982-2.826 0-1.038.445-1.734 1.038-2.13a2.211 2.211 0 01-.398-1.27c0-.657.242-1.192.617-1.509-.313-.333-.797-.945-.797-2.307 0-2.137 1.218-3.206 3.475-3.206h4.575v2.431h.016zm-4.536 7.162c-1.055 0-1.586.24-1.586.837 0 .588.531.836 1.586.836 1.061 0 1.592-.248 1.592-.836 0-.597-.53-.837-1.592-.837zm-1.172-6.387c0 .673.328 1.122 1.133 1.122.796 0 1.132-.449 1.132-1.122 0-.682-.336-1.123-1.132-1.123-.805 0-1.133.433-1.133 1.123zM94.593 27.348v6.604c0 .836.195 1.007.624 1.007a.948.948 0 00.461-.132v1.247c-.554.31-1.132.48-1.725.48-.672 0-1.195-.264-1.523-.697a3.258 3.258 0 01-2.022.697c-2.35 0-3.545-1.65-3.545-4.607 0-2.966 1.195-4.615 3.545-4.615.843 0 1.57.31 2.147.836l2.038-.82zm-2.561 3.05a1.525 1.525 0 00-1.265-.658c-1 0-1.327.798-1.327 2.222 0 1.425.328 2.215 1.327 2.215.508 0 .976-.24 1.265-.658v-3.12zM102.737 27.24v2.763c-.641 0-1.788.419-2.476.945v5.397h-2.568v-8.27l2.568-1.06v1.432c.75-.704 1.921-1.208 2.476-1.208zM103.4 27.572h2.749l1.413 3.88 1.413-3.88h2.741l-2.967 8.076c-1.437 3.91-2.319 5.49-4.951 5.048V38.39c.992.046 1.218-.062 2.39-3.206l-2.788-7.61zM37.83 40.828a23.198 23.198 0 01-14.64 5.164C10.383 46 0 35.702 0 22.996S10.384 0 23.19 0c2.092 0 4.122.279 6.058.798v11.8h-9.15c-5.06 0-7.808 2.717-7.808 7.742V33.1c0 5.072 2.748 7.728 7.808 7.728h17.731z"
        fill="inherit"
      />
      <path
        d="M17.052 20.34V33.1c0 2.052 1.039 3.012 3.053 3.012h9.143v-18.8h-9.15c-2.007 0-3.046 1.03-3.046 3.028zM34.003 2.648v33.449l8.238.015a22.755 22.755 0 004.138-13.116c0-8.827-5.02-16.492-12.376-20.348z"
        fill="inherit"
      />
    </svg>
  </Link>
)

const CloseButton = ({ color, ...rest }) => (
  <button
    title="Close"
    css={css({
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: 64,
      height: 64,
      m: 0,
      p: 0,
      border: 0,
      bg: "transparent",
      appearance: "none",
      cursor: "pointer",
      "&:focus": { outline: 0 },
      "::-moz-focus-inner": { border: 0 },
    })}
    {...rest}
  >
    <svg
      width={32}
      height={32}
      viewBox="0 0 40 40"
      fill="none"
      css={css({ color: color ? color : "#fff" })}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.914 20l9.293-9.293L29.5 10l-9.293 9.293L10.914 10l-.707.707L19.5 20 10 29.5l.707.707 9.5-9.5 9.5 9.5.707-.707-9.5-9.5z"
        fill="currentColor"
      />
    </svg>
  </button>
)

function Menu({ id, bg, color, logo, children, showDialog, setShowDialog }) {
  return (
    <AnimatePresence>
      {showDialog && (
        <DialogOverlay
          onDismiss={() => setShowDialog(!showDialog)}
          css={css({
            zIndex: 10000,
            bg: "transparent",
            //cursor: `url(${closeCursor}), auto`,
            overflow: "hidden",
          })}
        >
          <motion.div
            variants={{
              initial: {
                scaleY: 0,
              },
              enter: {
                scaleY: 1,
                transition: {
                  duration: 0.3,
                  when: "beforeChildren",
                },
              },
              exit: {
                scaleY: 0,
                transition: {
                  duration: 0.15,
                  when: "afterChildren",
                },
              },
            }}
            initial="initial"
            animate="enter"
            exit="exit"
            style={{ transformOrigin: "bottom" }}
          >
            <DialogContent
              css={css({
                position: "relative",
                zIndex: 3,
                width: "100%",
                minHeight: "calc(var(--vh, 1vh) * 100)",
                my: 0,
                p: 0,
                cursor: "auto",
                bg: bg ? bg : "text",
              })}
            >
              <Box
                position="relative"
                width="100%"
                minHeight={["calc(var(--vh, 1vh) * 100)"]}
              >
                <motion.div
                  variants={{
                    initial: {
                      opacity: 0,
                    },
                    enter: {
                      opacity: 1,
                      transition: {
                        duration: 0.2,
                      },
                    },
                    exit: {
                      opacity: 0,
                      transition: { duration: 0.1 },
                    },
                  }}
                >
                  {/* ======================== LOGO & CLOSING ======================== */}
                  <Flex
                    position="absolute"
                    bottom={0}
                    left={0}
                    zIndex={1}
                    justifyContent="space-between"
                    alignItems="center"
                    width="100%"
                    minHeight={64}
                    pl={24}
                    pb="env(safe-area-inset-bottom)"
                    bg={bg ? bg : "text"}
                  >
                    {logo ? (
                      logo
                    ) : (
                      <Logo onClick={() => setShowDialog(!showDialog)} />
                    )}
                    <CloseButton
                      onClick={() => setShowDialog(!showDialog)}
                      color={color}
                    />
                  </Flex>
                  <Box
                    css={css({
                      position: "absolute",
                      top: "env(safe-area-inset-bottom)",
                      left: 0,
                      width: "100%",
                      height: "100%",
                      overflowY: "scroll",
                      overflowX: "hidden",
                      WebkitOverflowScrolling: "touch",
                    })}
                    id={id + "sidebarScroll"}
                  >
                    {children}
                  </Box>
                </motion.div>
              </Box>
            </DialogContent>
          </motion.div>
        </DialogOverlay>
      )}
    </AnimatePresence>
  )
}

export default Menu
